import type { ButtonHTMLAttributes, ElementType, ReactNode } from 'react';
import { Button as RsButton } from 'reactstrap';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  color?: string;
  outline?: boolean;
  block?: boolean;
  size?: string;
  className?: string;
  tag?: ElementType;
  to?: string;
}

export function Button({
  children,
  color = 'primary',
  outline,
  block,
  size,
  className,
  type = 'button',
  tag,
  to,
  ...rest
}: Props) {
  return (
    <RsButton
      color={color}
      outline={outline}
      block={block}
      size={size}
      className={className}
      type={type}
      tag={tag}
      to={to}
      {...rest}
    >
      {children}
    </RsButton>
  );
}
